import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import NodeAPI from "../api";
import { Typography, CircularProgress, Alert, Box, Paper, Button } from "@mui/material";


const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("verifying");
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get("token");

        if (!token) {
            setErrorMessage("Missing verification token.");
            setStatus("error");
            return;
        }

        const verify = async () => {
            try {
                console.log("Verifying with token:", token);
                
                const response = await NodeAPI.get(`/auth/verify-email?token=${token}`);
                console.log("Verification response:", response.data);
                console.log("Token from URL:", token);

                setStatus("success");
            
                setTimeout(() => {
                    navigate("/");
                }, 3000);
            } catch (error) {
                const message = error?.response?.data?.msg || error?.message || "Unknown error";
                console.error("Verification failed:", message);
                setErrorMessage(message);
                setStatus("error");
            }
            
            
        };

        verify();
    }, [searchParams, navigate]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <Paper elevation={3} sx={{ padding: 4, width: 350, textAlign: "center" }}>
                {status === "verifying" && (
                    <>
                        <CircularProgress />
                        <Typography sx={{ mt: 2 }}>Verifying email...</Typography>
                    </>
                )}
                {status === "success" && (
                    <>
                        <Alert severity="success">Email verified! Redirecting to login...</Alert>
                        <Button 
                            variant="contained" 
                            sx={{ mt: 2 }} 
                            onClick={() => navigate("/")}
                        >
                            Go to Login
                        </Button>
                    </>
                )}
                {status === "error" && (
                    <>
                        <Alert severity="error">{errorMessage}</Alert>
                        <Button 
                            variant="outlined" 
                            sx={{ mt: 2 }} 
                            onClick={() => navigate("/")}
                        >
                            Go to Login
                        </Button>
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default VerifyEmail;


